import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { IGetReportEntregaObraClienteFotografico2UseCase } from "../../../presentation/useCases/read/get_report_entrega_obra_cliente_fotografico2_use_case";
import { ReportData } from "../../models/report_data";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IReportsRepository } from "../../repositories/reports_repository";

/**
 * GetReportEntregaObraClienteFotografico2UseCase
 */

export class GetReportEntregaObraClienteFotografico2UseCase implements IGetReportEntregaObraClienteFotografico2UseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async execute(
    requiredMimeType: ReportMimeType | null,
    idEntregaObraCliente: number,
    retrabalhos?: string[],
  ): Promise<ReportData> {
    const response = await this.repository.getReportEntregaObraClienteFotografico2(
      requiredMimeType,
      idEntregaObraCliente,
      retrabalhos
    );

    if (response.mimeType !== 'text/html') {
      const arquivoNome = `${response.filename}.${response.filenameExtension}`;
      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }

}
